import { render, staticRenderFns } from "./ViewSubmitted.vue?vue&type=template&id=0a03ff9a&"
import script from "./ViewSubmitted.vue?vue&type=script&lang=js&"
export * from "./ViewSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports